import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Logo, Button } from './ui';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    label: 'AI Designer',
    id: 'ai-designer'
  }, {
    label: 'How It Works',
    id: 'how-it-works'
  }, {
    label: 'Use Cases',
    id: 'use-cases'
  }, {
    label: 'Pricing',
    id: 'pricing'
  }, {
    label: 'Reports',
    id: 'reports'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate(`/#${id}`);
    } else {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        // Update URL hash without jumping
        window.history.pushState(null, '', `/#${id}`);
      }
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-4174">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-4175">
        <Link to="/" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-4176">
          <Logo data-id="element-4177" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-4178">
          <ul className="flex items-center gap-8" data-id="element-4179">
            {navItems.map(item => <li key={item.id} data-id="element-4180">
                <a href={`/#${item.id}`} onClick={e => handleNavClick(e, item.id)} className="text-sm font-medium text-slate-600 hover:text-brand-navy transition-colors" data-id="element-4181">
                  {item.label}
                </a>
              </li>)}
          </ul>
          <Button variant="primary" href="/designer" data-id="element-4182">
            Design Your Free Offsite
          </Button>
        </nav>

        {/* Mobile Toggle */}
        <button className="lg:hidden p-2 text-slate-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-4183">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-4184" /> : <MenuIcon className="w-6 h-6" data-id="element-4185" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-slate-100 shadow-lg py-4 px-6 flex flex-col gap-4" data-id="element-4186">
          {navItems.map(item => <a key={item.id} href={`/#${item.id}`} onClick={e => handleNavClick(e, item.id)} className="text-base font-medium text-slate-800 py-2 border-b border-slate-50" data-id="element-4187">
              {item.label}
            </a>)}
          <Button variant="primary" className="w-full mt-2" href="/designer" data-id="element-4188">
            Design Your Free Offsite
          </Button>
        </div>}
    </header>;
}